import { ApplicationConfig, APP_INITIALIZER, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';
import { MessageService, ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { ConfigService } from './core/services/config.service';

const KrcPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#faf6f2',
      100: '#f3ebe1',
      200: '#e6d3c0',
      300: '#d8ba9e',
      400: '#c9a37f',
      500: '#b8926a',
      600: '#a07d58',
      700: '#86684a',
      800: '#6d543c',
      900: '#57432f',
      950: '#3a2c1f',
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
    {
      provide: APP_INITIALIZER,
      useFactory: (config: ConfigService) => () => config.load(),
      deps: [ConfigService],
      multi: true,
    },
    provideAnimationsAsync(),
    providePrimeNG({ theme: { preset: KrcPreset, options: { darkModeSelector: false } } }),
    MessageService,
    ConfirmationService,
    DialogService,
  ],
};
